import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { ActivityType } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import Button from "@mui/material/Button";
import { ROUTER_PATHS } from "@/shared";
import { useNavigate } from "react-router-dom";

export const useTableColumnsActivityType = () => {
  const navigate = useNavigate();
  const ordenesDeTrabajoNocParametrosTipoActividadEditar = ROUTER_PATHS.noc.ordenesDeTrabajoNocParametrosTipoActividad;

  const columnsActivityType = useMemo<MRT_ColumnDef<ActivityType>[]>(
    () => [
      {
        accessorKey: 'idActivityType',
        header: 'ACCIONES',
        Cell: ({ row }) =>
          React.createElement(
            Button,
            {
              variant: "contained",
              onClick: () => {
                navigate(ordenesDeTrabajoNocParametrosTipoActividadEditar + '/editar/' + row.original.idActivityType)
              },
            },
            "Editar"
          )
      },
      {
        accessorKey: 'nameActivityType',
        header: 'NOMBRE DEL TIPO DE ACTIVIDAD',
      },
      {
        accessorKey: 'statusActivityType',
        header: 'ESTADO DEL TIPO DE ACTIVIDAD',
        Cell: ({ row }) => {
          return row.original.statusActivityType ? "Activo" : "Bloqueado";
        }
      },
    ],
    [],
  );

  return {
    columnsActivityType,
  }
}